import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { putData } from "../../../utils/api";
library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const { postData, getData, IMG_URL } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const GetEditData = async () => {
    const response = await getData(`/admin/masters/exchange-rate/${id}`);
    reset(response?.data);
  };
  useEffect(() => {
    GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    watch,
  } = useForm();

  const imageFile = watch("image");

  const onSubmit = async (data) => {
    try {
      const finalData = new FormData();
      finalData.append("rate", data?.rate);
      finalData.append("symbol", data?.symbol);
      finalData.append("code", data?.code);
      finalData.append("country", data?.country);
      const response = await putData(
        `/admin/masters/exchange-rate/${id}`,
        finalData,
      );

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const [imagePreview, setImagePreview] = useState(null); // State to store image preview

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Code
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row className="">
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>country</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="country"
                        placeholder="Country"
                        className={classNames("", {
                          "is-invalid": errors?.country,
                        })}
                        {...register("country", {
                          required: "Country is required",
                          validate: (value) =>
                            value.length <= 200 ||
                            "Data must be 200 characters or less",
                        })}
                      />
                    </InputGroup>
                    {errors.country && (
                     <span className="text-danger" style={{ fontSize: "14px" }} >
                        {errors.country.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Code</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="code"
                        placeholder="Code"
                        className={classNames("", {
                          "is-invalid": errors?.code,
                        })}
                        {...register("code", {
                          required: "Code is required",
                          validate: (value) =>
                            value.length <= 200 ||
                            "Data must be 200 characters or less",
                        })}
                      />
                    </InputGroup>
                    {errors.code && (
                     <span className="text-danger" style={{ fontSize: "14px" }} >
                        {errors.code.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Symbol</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="symbol"
                        placeholder="Symbol"
                        className={classNames("", {
                          "is-invalid": errors?.symbol,
                        })}
                        {...register("symbol", {
                          required: "Symbol is required",
                          validate: (value) =>
                            value.length <= 200 ||
                            "Data must be 200 characters or less",
                        })}
                      />
                    </InputGroup>
                    {errors.symbol && (
                     <span className="text-danger" style={{ fontSize: "14px" }} >
                        {errors.symbol.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Exchange Rate</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="exchange_rate"
                        placeholder="Exchange Rate"
                        className={classNames("", {
                          "is-invalid": errors?.rate,
                        })}
                        // ✅ allow only numbers and dot
                        onKeyPress={(e) => {
                          if (!/[0-9.]/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        // ✅ prevent invalid paste
                        onPaste={(e) => {
                          const pasteData = e.clipboardData.getData("text");
                          if (!/^\d*\.?\d*$/.test(pasteData)) {
                            e.preventDefault();
                          }
                        }}
                        {...register("rate", {
                          required: "Exchange Rate is required",
                          pattern: {
                            value: /^\d*\.?\d*$/,
                            message: "Only numbers allowed",
                          },
                        })}
                      />
                    </InputGroup>
                    {errors.rate && (
                     <span className="text-danger" style={{ fontSize: "14px" }} >{errors.rate.message}</span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
